import React from 'react';
import LocalizedStrings from 'react-localization';
import en from '../locales/en';
import ja from '../locales/ja';
const localizationObject = new LocalizedStrings({
  en,
  ja
});
const LocalizationContext = /*#__PURE__*/React.createContext(localizationObject);
export default LocalizationContext;